// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDxK1lO0SEmpBZSaY2muNPy19WJDawqGSM",
    authDomain: "softskillerp.firebaseapp.com",
    projectId: "softskillerp",
    storageBucket: "softskillerp.appspot.com",
    messagingSenderId: "491013719304",
    appId: "1:491013719304:web:01482e4b0b7307a06658bd",
    measurementId: "G-4HZP1MQ3YJ"
  },
  api: {

  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
